import {useEffect, useState} from 'react'
import {
  GetOrganisationAccessDocument,
  GetOrganisationAccessQuery
} from '../data/workbench-api/generated/organisation'
import {OrganisationAccess} from '../data/workbench-api/generated/types'
import {getClient} from '../lib/api'
import {AuthState} from '../lib/cognito'
import {useOrganisations} from '../lib/organisations'

export const useAllOrganisationAccess = (authState: AuthState) => {
  const [orgs] = useOrganisations()
  const [organisations, setOrganisations] = useState<
    OrganisationAccess[] | undefined
  >(undefined)

  useEffect(() => {
    if (authState.authenticated && orgs.length) {
      Promise.all(
        orgs.map(org => {
          return getClient(org.id)
            .query<GetOrganisationAccessQuery>({
              query: GetOrganisationAccessDocument,
              variables: {id: org.id}
            })
            .then(resp => resp.data.getOrganisationAccess)
        })
      ).then(orgAccess => {
        setOrganisations(orgAccess.filter(Boolean) as OrganisationAccess[])
      })
    }
  }, [orgs, authState.authenticated])

  return {organisations}
}
